import React from 'react'
import { InputControl } from 'formik-chakra-ui'
import { t } from '@lingui/macro'
import { useInputMaskingToggle } from '../../useInputMaskingToggle'
import { FormRow } from './FormRow'
import { UserExtraValidationSchemaEnum } from 'shared/entities-validator/user-fields-validators'
import { InputProps } from '@chakra-ui/react'
import { Box } from 'front-end/src/components'

export const PasswordField: React.FC = () => {
  const { isUnmasked, eyeButton } = useInputMaskingToggle({
    buttonProps: { zIndex: 2, boxSize: '32px' }
  })
  return (
    <>
      <FormRow position="relative">
        <Box right={0} position="absolute">
          {eyeButton}
        </Box>
        <InputControl
          inputProps={
            {
              type: isUnmasked ? 'text' : 'password',
              autoComplete: 'new-password',
              passwordrules:
                'minlength: 8; required: digit;required: lower; required: upper; required: [-];'
            } as InputProps
          }
          name={UserExtraValidationSchemaEnum.PASSWORD}
          label={t`Create password`}
        />
      </FormRow>
      <FormRow>
        <InputControl
          inputProps={{
            type: isUnmasked ? 'text' : 'password',
            autoComplete: 'new-password'
          }}
          name={UserExtraValidationSchemaEnum.PASSWORD_CONFIRMATION}
          label={t`Confirmation password`}
        />
      </FormRow>
    </>
  )
}
